import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-powerBank",
  "use": "icon-powerBank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-powerBank\"><path d=\"M620.8 492.8h-119.466667l93.866667-132.266667-64-44.8-136.533333 192c-19.2 25.6 0 59.733333 32 59.733334h119.466666l-93.866666 132.266666 64 44.8 136.533333-192c17.066667-25.6-2.133333-59.733333-32-59.733333z m0 0h-119.466667l93.866667-132.266667-64-44.8-136.533333 192c-19.2 25.6 0 59.733333 32 59.733334h119.466666l-93.866666 132.266666 64 44.8 136.533333-192c17.066667-25.6-2.133333-59.733333-32-59.733333z\" fill=\"#ffffff\" p-id=\"8657\" /><path d=\"M814.933333 166.4h-136.533333c0-21.333333-17.066667-38.4-38.4-38.4H405.333333c-21.333333 0-38.4 17.066667-38.4 38.4h-136.533333c-21.333333 0-38.4 17.066667-38.4 38.4v652.8c0 21.333333 17.066667 38.4 38.4 38.4h584.533333c21.333333 0 38.4-17.066667 38.4-38.4V204.8c0-21.333333-17.066667-38.4-38.4-38.4z m-40.533333 652.8H270.933333v-576h174.933334V204.8h155.733333v38.4h174.933333v576h-2.133333z\" fill=\"#ffffff\" p-id=\"8658\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/powerBank.svg
// module id = J+Wm
// module chunks = 53